module.exports = __webpack_public_path__ + "static/meshplate-000f328bdb3a41f3f9c922105ed16c44.jpg";